import type { FieldsetField } from './FieldsetValidator';
import { validators } from './validators';

/**
 * Get the first relevant error message for the field
 *
 * @return {String} Error message
 */
export default function errorMessage(
  field: FieldsetField,
  valid: any
): string | null {
  if (!valid) {
    let msg = field.label ? field.label : field.hint;

    if (!msg) {
      msg = field.name;
    }

    return validators.message(msg, field.type || 'required');
  }

  return null;
}
